<div class="right-side p-5">

  <div class="loader-container" *ngIf="loadingSequence">
    <div class="three-strings">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="processing-text">Processing...</div>
  </div>


  <div class="section">
    <div class="card mb-3">
      <div class="card-header"><h2>Event Details</h2></div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Event ID : </label><label>{{ eventObj.list1[0].eventId }}</label>
          </div>
          <div class="col-md-4">
            <label>Event organized by : </label><label>{{ eventObj.list1[0].nameOfOrganisation }}</label>
          </div>
          <div class="col-md-4">
            <label>Event Name : </label><label>{{ eventObj.list1[0].eventName }}</label>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Event Focus Sector : </label><label>{{ eventObj.list1[0].focusSectorName }}</label>
          </div>
          <div class="col-md-4">
            <label>Intervention : </label><label>{{ eventObj.list1[0].interventionName }}</label>
          </div>
          <div class="col-md-4">
            <label>Component : </label><label>{{ eventObj.list1[0].interestName }}</label>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Date of Event : </label><label>{{ eventObj.list1[0].eventDate }}</label>
          </div>
          <div class="col-md-4">
            <label>Time : </label><label>{{ eventObj.list1[0].time }}</label>
          </div>
          <div class="col-md-4">
            <label>District : </label><label>{{ eventObj.list1[0].districtName }}</label>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <label>City : </label><label>{{ eventObj.list1[0].cityName }}</label>
          </div>
          <div class="col-md-4">
            <label>Town/Block : </label><label>{{ eventObj.list1[0].townId }}</label>
          </div>
          <div class="col-md-4">
            <label>Village : </label><label>{{ eventObj.list1[0].village }}</label>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Venue Details : </label><label>{{ eventObj.list1[0].venueDetails }}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header"> <h2>Instructor Details</h2></div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th class="text-center">Anchor/Trainer name</th>
                <th class="text-center">Anchor/Trainer Company name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let trainer of eventObj.list3">
                <td class="text-center">{{ trainer.trainerName }}</td>
                <td class="text-center">{{ trainer.trainerCompanyName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header"><h2>SPOC Details</h2></div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th class="text-center">SPOC Name</th>
                <th class="text-center">IA SPOC Mobile number</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let spoc of eventObj.list2">
                <td class="text-center">{{ spoc.spocName }}</td>
                <td class="text-center">{{ spoc.iaspocMobileNumber }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card mb-3">
      <div class="card-header"> <h2>Enrolled Participants Details</h2></div>
      <div class="card-body">


        <!--If no participants are available, show a message-->
        <div *ngIf="!participantObj?.status">
          <p>No participants registered for this event.</p>
        </div>

        <!-- Display table if participants data exists -->
        <div class="table-responsive">
          <table class="table table-striped  table-bordered table-hover">
            <thead>
              <tr>
                <th class="text-center">SR. No.</th>
                <th class="text-center">Enrollment ID</th>
                <th class="text-center">Participant Name</th>
                <th class="text-center">Designation</th>
                <th class="text-center">Mobile Number</th>
                <th class="text-center">Email ID</th>
                <th class="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              <!-- Loop through the participants data -->
              <tr *ngFor="let participant of participantObj?.data; let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-center">{{ participant.enrollmentId }}</td>
                <td class="text-center">
                  {{ participant.participantName }}
                </td>
                <td class="text-center">
                  {{ participant.designation }}
                </td>
                <td class="text-center">
                  {{ participant.mobileNumber }}
                </td>
                <td class="text-center">
                  {{ participant.emailId }}
                </td>
                <td>
                  <!-- You can add action buttons like Edit/Delete here -->
                  <button class="btn btn-primary btn-sm me-1" (click)="updateParticipant(participant)"><i class="bi bi-pencil"></i> Edit</button>
                  <button class="btn btn-danger btn-sm" (click)="openConfirmationDialog(participant.enrollmentId)"><i class="bi bi-trash"></i> Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="card mb-3">
      <div class="card-header"> <h2>Add New Participant</h2></div>
      <div class="card-body">
        <form [formGroup]="eventForm">

          <div class="row">
            <div class="col-md-3">
              <label>Participant name <span class="text-danger">*</span></label>
              <input type="text" formControlName="participantName" class="form-control" />
              <div *ngIf="eventForm.get('participantName')?.touched && eventForm.get('participantName')?.invalid" class="alert alert-danger">
                <!--<div *ngIf="eventForm.get('participantName')?.hasError('required')">
                  Participant name is required.
                </div>-->
                <div *ngIf="eventForm.get('participantName')?.hasError('pattern')">
                  Participant name can only contain letters and spaces.
                </div>
                <div *ngIf="eventForm.get('participantName')?.hasError('minlength')">
                  Participant name must be at least 3 characters long.
                </div>
                <div *ngIf="eventForm.get('participantName')?.hasError('maxlength')">
                  Participant name must be maximum 50 characters long.
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <label>Designation <span class="text-danger">*</span></label>
              <input type="text" formControlName="participantDesignation" class="form-control" />
              <div *ngIf="eventForm.get('participantDesignation')?.touched && eventForm.get('participantDesignation')?.invalid" class="alert alert-danger">
                <!--<div *ngIf="eventForm.get('participantDesignation')?.hasError('required')">
                  Participant name is required.
                </div>-->
                <div *ngIf="eventForm.get('participantDesignation')?.hasError('pattern')">
                  Designation  can only contain letters and spaces.
                </div>
                <div *ngIf="eventForm.get('participantDesignation')?.hasError('minlength')">
                  Designation name must be at least 3 characters long.
                </div>
                <div *ngIf="eventForm.get('participantDesignation')?.hasError('maxlength')">
                  Designation name must be maximum 50 characters long.
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <label>Email Id <span class="text-danger">*</span></label>
              <input type="email" formControlName="participantEmailId" class="form-control" />
              <div *ngIf="eventForm.get('participantEmailId')?.touched && eventForm.get('participantEmailId')?.invalid" class="alert alert-danger">
                <!--<div *ngIf="eventForm.get('participantEmailId')?.hasError('required')">
                  Please enter a valid 10-digit mobile number.
                </div>-->
                <div *ngIf="eventForm.get('participantEmailId')?.hasError('pattern')">
                  Please enter a valid Email
                </div>
                <div *ngIf="eventForm.get('participantEmailId')?.hasError('maxlength')">
                  Email must be maximum 40 characters long.
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <label>Mobile Number <span class="text-danger">*</span></label>
              <input type="text" formControlName="participantMobile" maxlength="10" (keypress)="numberOnly($event)" class="form-control" />
              <div *ngIf="eventForm.get('participantMobile')?.touched && eventForm.get('participantMobile')?.invalid" class="alert alert-danger">
                <!--<div *ngIf="eventForm.get('participantMobile')?.hasError('required')">
                  Please enter a valid 10-digit mobile number.
                </div>-->
                <div *ngIf="eventForm.get('participantMobile')?.hasError('pattern')">
                  Please enter a valid 10-digit mobile number.
                </div>
              </div>
            </div>
          </div>
          <!--<div class="mt-2">
            <button type="button" (click)="addParticipant()" class="btn btn-primary btn-sm">Add more</button>
          </div>-->
          <br />
          <div class="text-center">
            <button type="submit" (click)="onSubmit()" class="btn btn-success" [disabled]="disableButton">{{ isEditMode ? 'Update' : 'Add' }}</button>
            <button (click)="onPressBack()" class="btn btn-info mx-2">Back</button>
            <button (click)="resetForm()" class="btn btn-danger">Cancel</button>
          </div>
        </form>
      </div>
    </div>


  </div>
</div>
